export default "__VITE_ASSET__BLCU4kOc__"